// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Favourites  (the heart on product cards and the product page)
// A toggle button for "save this catch". `aria-pressed` carries the state; the label names the catch. Only rendered for
// signed-in customers (callers omit it otherwise). Neighbours: hooks/useFavouriteCatches, components/menu/ProductCard.
// ─────────────────────────────────────────────────────────────────────────────
import { Heart } from "lucide-react";

interface FavouriteHeartProps {
  name: string;
  saved: boolean;
  onToggle: () => void;
  className?: string;
}

export default function FavouriteHeart({ name, saved, onToggle, className = "" }: FavouriteHeartProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={saved}
      aria-label={saved ? `Remove ${name} from favourites` : `Save ${name} to favourites`}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-coral-600 shadow-sm ring-1 ring-ocean-900/10 hover:bg-coral-500/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 dark:bg-ocean-900 dark:text-coral-300 dark:ring-white/10 ${className}`}
    >
      <Heart className={`h-5 w-5 ${saved ? "fill-current" : ""}`} aria-hidden="true" />
    </button>
  );
}
